import React from 'react'
import ResultReport from './ResultReport';
import { useState, useRef, useEffect, useLayoutEffect,useCallback } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
const ManagementStatus = window.SIMPL.ManagementStatus;

export default function ManagementPanelReport(props) {
    
    const [showAllFilter, setShowAllFilter] = useState(false);
    const [resultAreaHeight, setResultAreaHeight] = useState(0);
    const [ResultHeight, setResultHeight] = useState(0);

    const ManagementPanelReportContainerRef = useRef(null);
    const workAreaRef = useRef(null);
    const resultAreaRef = useRef(null);
    const ResultRef = useRef(null);
   
    useLayoutEffect(() => {
        // 管理パネルの高さを再計算
        if (ResultRef.current) {
            let margin = props.isMobileMode ? 51 : 81;
            let searchAreaHeight =  showAllFilter ? 285 : 49;
            let size = props.height - searchAreaHeight - workAreaRef.current.clientHeight - margin+10;
            setResultAreaHeight(
                size > 100 ? size + 'px' : 140 + 'px'
            );
            setResultHeight(
                size > 100 ? (size - 55)  : 40 
            );
        }
    }, [props.height, props.isMobileMode,showAllFilter]); //ウィンドウ高さが変わったとき

    useEffect(() => {
        // スクロール位置をリセット
        if (ResultRef.current) {
            ResultRef.current.scrollTop = 0;
        }
    }, [props.items]);  //内容が変わったとき

    function getContainerSize() {
        return {
            width: props.width <= 1280 ? "640px" : props.width / 2  > 700 ? "700px": props.width / 2 +"px",
            height:  props.height > 520 ? "calc(100vh - 50px)" : "520px"
        };
    }
    
    const onSearchClick = useCallback(() => {
        if (!props.isSearching) {
            props.search("search");
        }
    }, [props]);

    const onKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onSearchClick();
        }
    }, [onSearchClick]);

    return (
        <div className="ManagementPanelReportContainer" ref={ManagementPanelReportContainerRef} style={getContainerSize()}>
            <div className="ManagementPanelReport">
            <div className="accordion">
                <div className="accordion-header">
                    <button type="button" className="accordion-button collapsed"
                        data-toggle="collapse" data-target="#panelsStayOpen-collapseOne"
                        onClick={()=>setShowAllFilter(!showAllFilter)}>
                        <label htmlFor="block-01">フィルタ</label>
                    </button>
                </div>
                    <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse">
                        <div className="accordion-body">
                            <form className="searchArea_Items">
                                <div className="searchArea_Item_2">
                                    <div className="searchArea_Item" style={{width:"194px"}}>
                                        <label>通報の状態</label>
                                        <div style={{display:"flex"}}>
                                            <select style={{width:'180px'}}
                                                value={props.filters.reportStatus}
                                                onChange={(e)=>props.onChangeFilter("reportStatus",e.target.value)}
                                                disabled={props.isUpdate}>
                                                    <option value="" ></option>
                                                    {ManagementStatus["reportStatus"].map((data,index)=><option  value={data.no} key={index}>{data.name}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="searchArea_check">
                                        <FormControlLabel control={<Checkbox 
                                            checked={props.filters.searchScope}
                                            disabled={props.isUpdate}
                                            onChange={(e)=>props.onChangeFilter("searchScope",e.target.checked)}
                                        />} label="現在の地図範囲を検索" className="searchArea_check_item" sx={{margin:"0",height:"34px"}}/>
                                    </div>
                                </div>
                                
                                    <div className={"searchArea_Item"}>
                                    <label style={{width:"100%"}}>キーワード</label>
                                    <input type="search"
                                        name="filters_keyword"
                                        value={props.filters.keyword}
                                        onChange={(e)=>props.onChangeFilter("keyword",e.target.value)}
                                        style={{width:'calc(100% - 15px)'}}
                                        disabled={props.isUpdate}
                                        onKeyPress={onKeyPress}/>
                                </div>

                                <div className={"searchArea_Item search_dateTime"}>
                                    <label>通報日</label>
                                    <div style={{marginLeft:'15px'}}>
                                        <input type="date"
                                            value={props.filters.reportDate_str}
                                            onChange={(e)=>props.onChangeFilter("reportDate_str",e.target.value)}
                                            disabled={props.isUpdate}
                                            max={props.filters.reportDate_end}
                                            />
                                        <span style={{margin:'0 5px'}}>～</span>
                                        <input type="date"
                                            value={props.filters.reportDate_end}
                                            onChange={(e)=>props.onChangeFilter("reportDate_end",e.target.value)}
                                            disabled={props.isUpdate}
                                            min={props.filters.reportDate_str}/>
                                    </div>
                                </div>
                            </form>
                            <div className="searchArea_Buttons">
                                <div className="searchArea_Buttons_right">
                                    <Button className="searchButton"
                                        onClick={onSearchClick}
                                        variant="contained"
                                        disabled={props.isUpdate}
                                        size="small"
                                        sx={{width:"70px",minWidth:"70px",margin:"0 5px",padding:"3px 10px",fontSize:"14px"}}
                                        >
                                            検索
                                    </Button>
                                    <Button id="clearButton"
                                        onClick={()=>props.onClearClick()}
                                        variant="outlined"
                                        disabled={props.isUpdate}
                                        size="small"
                                        sx={{width:"70px",minWidth:"70px",margin:"0 5px",padding:"3px 10px",fontSize:"14px",fontWeight:"bold",borderColor:"#444444",color:"#444444"}}
                                        >
                                            クリア
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sr-line"></div>

                <div className="workArea"  ref={workAreaRef}>
                    <button className="removeButton"
                        disabled={props.isUpdate || props.removeItems == null || props.removeItems.length <= 0}
                        onClick={props.setShowDeleteDialog}> 
                        <DeleteIcon />
                        削除
                    </button>
                </div>

                <div className="sr-line"></div> 

                <div className={"resultArea"}   ref={resultAreaRef} style={{ height: resultAreaHeight}}>
                    <div className="resultLabel">
                        <div className="resultLabel_Buttons_left">
                            <span style={{display:"inline-block",marginLeft:'10px',fontSize:"15px"}}>
                                {props.resultCount >= 1000 ?
                                    "1000件以上見つかりました。(上位100件まで表示)"
                                :
                                    props.resultCount === 0 ?
                                        `データが見つかりませんでした。`
                                    :
                                        props.resultCount > 100 ?
                                            `${props.resultCount}件見つかりました。(上位100件まで表示)`
                                        :
                                            `${props.resultCount}件見つかりました。`
                                }
                                </span>
                        </div>
                        <div className="resultLabel_Buttons_right">
                            <select
                                className='sortSelect'
                                style={{width:'200px'}}
                                defaultValue={"Report.reportDate desc"}
                                onChange={(e)=>props.onChangeSortType(e.target.value)}
                                disabled={props.isUpdate}>
                                <option value="Report.reportDate asc">通報日-昇順</option>
                                <option value="Report.reportDate desc">通報日-降順</option>
                                <option value="Managementinformation.modifiedDateTime asc">最終更新日時-昇順</option>
                                <option value="Managementinformation.modifiedDateTime desc">最終更新日時-降順</option>
                            </select>
                        </div>
                    </div>

                    <div  ref={ResultRef} style={{ height: ResultHeight + 2 + 'px'}}>
                        <ResultReport 
                            items={props.items}
                            selectedItem={props.selectedItem}
                            oldSelectedItem={props.oldSelectedItem}
                            onChangeSelectedRowAndEditClear={props.onChangeSelectedRowAndEditClear}
                            onTagClick={props.onTagClick}
                            removeItems={props.removeItems}
                            onChangeRemoveCheck={props.onChangeRemoveCheck}
                            onChangeRemoveAllCheck={props.onChangeRemoveAllCheck}
                            ResultHeight={ResultHeight}
                            onEnterItem={props.onEnterItem}
                            onLeaveItem={props.onLeaveItem}
                            isUpdate={props.isUpdate}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
}

